type LinkedItemProps = {
  children: JSX.Element;
};

export const LinkedItem = ({ children }: LinkedItemProps) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };
  return <div onClick={handleClick}>{children}</div>;
};
